import Swiper, { Autoplay, EffectCreative, Navigation, Pagination } from "swiper";

document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".text-with-title__slider");

  if (slider) {
    const prevEl = slider.querySelector(".slider-navigation__button--prev");
    const nextEl = slider.querySelector(".slider-navigation__button--next");
    const slides = slider.querySelectorAll(".text-with-title__slide");
    const swiper = new Swiper(slider, {
      modules: [EffectCreative, Pagination, Autoplay, Navigation],
      effect: "creative",
      parallax: true,
      speed: 1000,
      spaceBetween: 2,
      loop: slides.length > 1,
      creativeEffect: {
        prev: {
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      pagination: {
        el: ".text-with-title__pagination-list",
        bulletClass: "text-with-title___pagination pagination__item",
        bulletActiveClass: "pagination__item--active",
        clickable: true,
      },
      navigation: {
        prevEl,
        nextEl,
      },
    });

    const paginations = slider.querySelectorAll(".text-with-title___pagination");
    let throttleTime = 10000;
    let throttle;
    let activeIndex = 0;
    const startTimeout = () => {
      clearTimeout(throttle);
      throttle = setTimeout(() => {
        throttleTime = 10000;
        swiper.slideNext();
      }, throttleTime);
      changeSoundVideo();
    };

    let checkMuted = false;

    let sounds = document.querySelectorAll(".text-with-title__sound input");

    const changeSoundVideo = () => {
      swiper.slides.forEach((slide) => {
        const videos = slide.querySelectorAll("video");
        if (videos) {
          videos.forEach((video) => {
            video.muted = !checkMuted;
          });
        }
      });
    };

    const changeSound = (checked) => {
      sounds.forEach((sound) => {
        sound.checked = checked;
      });
    };

    sounds.forEach((sound) => {
      sound.addEventListener("change", () => {
        checkMuted = sound.checked;
        changeSound(sound.checked);
        changeSoundVideo();
      });
    });

    const checkVideo = () => {
      const oldVideos = swiper.slides[activeIndex]?.querySelectorAll("video");
      if (oldVideos) {
        oldVideos.forEach((video) => {
          video.pause();
        });
      }
      setTimeout(() => {
        activeIndex = swiper.activeIndex;
        const videos = swiper.slides[activeIndex]?.querySelectorAll("video");
        if (videos) {
          videos.forEach((video) => {
            if (video.classList.contains("text-with-title__video--mobile") && window.innerWidth < 780) {
              video.play();
            }
            if (!video.classList.contains("text-with-title__video--mobile") && window.innerWidth >= 780) {
              video.play();
            }
            changeSoundVideo();
          });
        }
      }, 1000);
    };

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paginations[0].classList.remove("pagination__item--active");
            setTimeout(() => {
              paginations[0].classList.add("pagination__item--active");
            }, 5);
            startTimeout();
            checkVideo();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(slider);

    swiper.on("slideChange", () => {
      startTimeout();
      checkVideo();
    });

    prevEl.addEventListener("click", () => {
      throttleTime = 30000;
    });

    nextEl.addEventListener("click", () => {
      throttleTime = 30000;
    });

    swiper.on("touchMove", () => {
      throttleTime = 30000;
    });
  }

  const text = document.querySelector(".text-with-title__text");

  if (text) {
    const lists = text.querySelectorAll("ol");

    if (lists) {
      lists.forEach((list) => {
        const items = list.querySelectorAll("li");

        if (items) {
          items.forEach((item, index) => {
            const div = document.createElement("div");
            div.appendChild(item.cloneNode(true));
            const span = document.createElement("span");
            span.innerHTML = `${index + 1}.`;

            item.innerHTML = "";
            item.appendChild(span);
            item.appendChild(div);
          });
        }
      });
    }
    const childs = [];
    text.childNodes.forEach((child, index) => {
      if (!child.innerText) {
        return;
      }
      if (!child.innerText.trim().length) {
        return;
      }
      childs.push(child);
      if (index !== text.childNodes.length - 1) {
        childs.push(document.createElement("br"));
      }
    });
    if (text.tagName != "P" && text.tagName != "DIV") {
      text.innerHTML = "";
    }
    childs.forEach((item) => {
      text.appendChild(item);
    });
  }
});
